<template lang="pug">
  v-dialog(v-model="visible" persistent width='480px')
    v-card
      title-bar(:loading="customFieldsIsLoading" dark) Insert LionDesk Fields
      v-card-text(data-cy="liondesk-content-modal")
        v-select(
          data-cy="contact-agent-content"
          label="Select contact or agent info"
          v-model="selectedValue"
          :items="contactUserInfo"
        )
        v-select(
          data-cy="custom-field-content"
          label="Select a custom field"
          v-model="selectedValue"
          :items="customFields"
        )
      v-card-actions
        v-spacer
        v-btn(
          flat
          data-cy="liondesk-content-cancel"
          @click="$emit('close')"
        ) Cancel
        v-btn.primary(
          data-cy="liondesk-content-submit"
          @click="insertValue"
          :disabled="!selectedValue"
        ) Insert
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { LIONDESK_CUSTOM_CONTENTS } from '@/Communications/config/custom-content';
import TitleBar from '@/Core/components/TitleBar';

const { mapState, mapActions } = createNamespacedHelpers('communicationsCustomFields');

export default {
  components: {
    TitleBar,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(newValue) {
      if (newValue) this.findCustomFields();
      this.selectedValue = null;
    },
  },
  data() {
    return {
      contactUserInfo: LIONDESK_CUSTOM_CONTENTS,
      selectedValue: null,
    };
  },
  computed: {
    ...mapState({
      customFields: state => state.customFields,
      customFieldsIsLoading: state => state.isLoading,
    }),
  },
  methods: {
    ...mapActions(['findCustomFields']),
    insertValue() {
      this.$emit('insert', this.selectedValue);
    },
  },
};
</script>
